import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { AvBarChartComponent } from '../../../../../Shared/Components/av-bar-chart/av-bar-chart.component';
import { AvEmptyStateComponent } from '../../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { scaleCount } from '../../../../../Shared/Services/count-up-value.util';
import { TranslationService } from '../../../../../Shared/Services/translation.service';
import { COMMON_IMPORTS } from '../../../../../Shared/common-imports';
import { MonitoringCatalog } from '../../../Interfaces/monitoring-report.interface';
import { toKindBars } from '../../../Shared/monitoring-chart-data.util';

@Component({
  selector: 'app-monitoring-catalog-card',
  standalone: true,
  imports: [COMMON_IMPORTS, AvBarChartComponent, AvEmptyStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './monitoring-catalog-card.component.html',
  styleUrl: './monitoring-catalog-card.component.scss',
  host: { class: 'av-metric-card av-metric-card--compact' },
})
export class MonitoringCatalogCardComponent {
  readonly catalog = input.required<MonitoringCatalog>();
  readonly progress = input<number>(1);

  protected readonly language = inject(TranslationService).currentLanguage;

  protected readonly bars = computed(() => toKindBars(this.catalog()));

  protected readonly total = computed(() => scaleCount(this.catalog().total, this.progress()));
}
